import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Col, Form, Input, Modal, Row, Select, message, Image, SelectProps, Popconfirm, Space, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import HTTPService from '../../../utils/makerequest';
import { Toast } from 'primereact/toast';
import { IItemData } from '../../../interfaces/IItemData';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { StateLoader } from '../../../redux/StateLoader';
import { ILocationData } from '../../../interfaces/ILocationData';
import { ICampusData } from '../../../interfaces/ICampusData';
import { CloseOutlined, DeleteOutlined, PlusOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import AddLocation from '../LocationManagement/AddLocation';
import { ICategoryData } from '../../../interfaces/ICategoryData';
import { ITypeData } from '../../../interfaces/ITypeData';
import { IDepartmentData } from '../../../interfaces/IDepartmentData';
import { ISupplierData } from '../../../interfaces/ISupplierData';
import { IBrandData } from '../../../interfaces/IBrandData';
import { API_URL } from '../../../utils/Constants';
import { IInventoryStatusData } from '../../../interfaces/IInventoryStatusData';
import AddCategory from '../CategoryManagement/AddCategory';
import AddType from '../TypeManagement/AddType';
import AddDepartment from '../DepartmentManagement/AddDepartment';
import AddSupplier from '../SupplierManagement/AddSupplier';
import AddBrand from '../BrandManagement/AddBrand';
import AddInventoryStatus from '../InventoryStatus/AddInventoryStatus';
import AddCampus from '../CampusManagement/AddCampus';
import AltisDataGrid, { IAltisDataGridColumns } from '../../../AltisComponent/AltisDataGrid';
import { Box, Tab, Tabs } from '@mui/material';
import MaintenanceTab from './ModalClass/MaintenanceTab';
import WarrantyTab from './ModalClass/WarrantyTab';
import FileTab from './ModalClass/FileTab';
import SubPartsTab from './ModalClass/SubPartsTab';
import LockIcon from '@mui/icons-material/Lock';
import Dropdown from '../../../AltisComponent/Dropdown';


const UpdateInventory: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const { inventoryId } = useParams<{ inventoryId: string }>();
  const [itemData, setItemData] = useState<IItemData>({
    inventoryName: "",
    serialNo: "",
    location: "",
    itemType: 0,
    locationCity: "",
    responsibleFirstname: "",
    responsibleLastname: "",
    responsibleTelephone: "",
    responsibleEmail: "",
    barcode: "",
    imageUrl: "",
  });

  const [locationData, setLocationData] = useState<ILocationData[]>([]);
  const [inventoryStatusData, setInventoryStatusData] = useState<IInventoryStatusData[]>([]);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [categoryData, setCategoryData] = useState<ICategoryData[]>([]);
  const [supplierData, setSupplierData] = useState<ISupplierData[]>([]);
  const [departmentData, setDepartmentData] = useState<IDepartmentData[]>([]);
  const [campusData, setCampusData] = useState<ICampusData[]>([]);
  const [typeData, setTypeData] = useState<ITypeData[]>([]);
  const [brandData, setBrandData] = useState<IBrandData[]>([]);
  const [isModalVisibleCampus, setIsModalVisibleCampus] = useState(false);
  const [isModalVisibleInventoryStatus, setIsModalVisibleInventoryStatus] = useState(false);
  const [isModalVisibleCategory, setIsModalVisibleCategory] = useState(false);
  const [isModalVisibleLocation, setIsModalVisibleLocation] = useState(false);
  const [isModalVisibleSupplier, setIsModalVisibleSupplier] = useState(false);
  const [isModalVisibleType, setIsModalVisibleType] = useState(false);
  const [isModalVisibleDepartment, setIsModalVisibleDepartment] = useState(false);
  const [isModalVisibleBrand, setIsModalVisibleBrand] = useState(false);
  const [selectedCampus, setSelectedCampus] = useState(itemData?.locationTBL?.campusTBL.campusId || "");
  const [selectedLocation, setSelectedLocation] = useState(itemData?.locationId || "");
  const [selectedType, setSelectedType] = useState(itemData?.typeId || "");
  const [selectedCategory, setSelectedCategory] = useState(itemData?.itemTypeTBL?.categoryId || "");
  const [selectedSupplier, setSelectedSupplier] = useState(itemData?.supplierId || "");
  const [selectedDepartment, setSelectedDepartment] = useState(itemData?.departmentId || "");
  const [selectedStatus, setSelectedStatus] = useState(itemData?.inventoryStatusId || "");
  const [selectedBrand, setSelectedBrand] = useState(itemData?.brandId || "");
  const [filteredUserData, setFilteredUserData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState<number>();
  const [selectedResponsible, setSelectedResponsible] = useState(null);
  const [selectedDebit, setSelectedDebit] = useState(null);
  const [userData, setUserData] = useState([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [inventoryPictureTBL, setInventoryPictureTBL] = useState<any[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [isLocationExternal, setIsLocationExternal] = useState(false);

  const loader = new StateLoader();
  const user: IAuthentication = loader.loadAuthState();

  useEffect(() => {
    if (inventoryId !== "0") {
      fetchItemData(inventoryId);
    }
  }, [inventoryId]);


  useEffect(() => {
    if (!userData || !itemData?.inventoryResponsibleTBL) return;

    const responsibleList = itemData.inventoryResponsibleTBL.map(item => item.responsibleUserId);

    const filteredData = userData.filter(user => responsibleList.includes(user.userId));

    setFilteredUserData(filteredData);
  }, [userData, itemData]);

  useEffect(() => {
    if (selectedCompany) {
      fetchCampusByCompany(selectedCompany);
    } else {
      setCampusData([]);
    }
  }, [selectedCompany]);


  const fetchAllLocationName = async (companyId: number) => {
    try {
      const result = await HTTPService.GETAllLocationsNames(companyId);
      const filtered = result.filter(location => {
        const locationName = location.locationName?.toLowerCase() || '';
        return !locationName.includes('dışı') &&
          !locationName.includes('external') &&
          !locationName.includes('company outside');
      });
      setLocationData(filtered);
      return result; // Tüm veriyi döndür
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
      return [];
    }
  };

  const fetchAllCategoryName = async (companyId: number) => {
    try {
      const result = await HTTPService.GETCategoryByCompany(companyId);
      setCategoryData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  const fetchAllType = async (companyId: number) => {
    try {
      const result = await HTTPService.GETTypeNames(companyId);
      setTypeData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  const fetchAllTypeByCategory = async (categoryId: string) => {
    try {
      const result = await HTTPService.GETTypeNamesByCategory(categoryId.toString());
      setTypeData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };


  const fetchAllDepartment = async (companyId: number) => {
    try {
      const result = await HTTPService.GETDepartmentNames(companyId);
      setDepartmentData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  const fetchAllSupplier = async (companyId: number) => {
    try {
      const result = await HTTPService.GETSupplierNames(companyId);
      setSupplierData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  const fetchAllBrand = async (companyId: number) => {
    try {
      const result = await HTTPService.GETBrandNames(companyId);
      setBrandData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };


  const fetchAllStatus = async (companyId: number) => {
    try {
      const result = await HTTPService.GETInventoryStatusNames(companyId);
      setInventoryStatusData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  useEffect(() => {
    if (tabIndex === 0 && itemData && isLocationExternal) {
      if (itemData.locationTBL?.campusTBL) {
        setCampusData(prev => {
          const exists = prev.find(c => c.campusId === itemData.locationTBL.campusTBL.campusId);
          if (!exists) {
            return [...prev, itemData.locationTBL.campusTBL];
          }
          return prev;
        });
      }

      if (itemData.locationTBL) {
        setLocationData(prev => {
          const exists = prev.find(l => l.locationId === itemData.locationId);
          if (!exists) {
            return [...prev, itemData.locationTBL];
          }
          return prev;
        });
      }
    }
  }, [tabIndex, itemData, isLocationExternal]);


  const fetchItemData = async (inventoryId: string) => {
    try {
      const res = await HTTPService.GET(`/Inventory/ById?inventoryId=${inventoryId}`);

      if (res.status === 200) {
        const filteredImages = res.data.inventoryPictureTBL.filter(picture =>
          picture.fileType && picture.fileType.includes('image')
        );

        const locationName = res.data.locationTBL?.locationName || '';
        const campusName = res.data.locationTBL?.campusTBL?.campusName || '';

        const isExternal =
          locationName.toLowerCase().includes('dışı') ||
          locationName.toLowerCase().includes('external') ||
          locationName.toLowerCase().includes('company outside') ||
          campusName.toLowerCase().includes('dışı') ||
          campusName.toLowerCase().includes('external') ||
          campusName.toLowerCase().includes('company outside');

        setIsLocationExternal(isExternal);

        setItemData({
          ...res.data,
          inventoryPictureTBL: filteredImages
        });

        const allLocations = await fetchAllLocationName(res.data.companyId);
        const allCampuses = await fetchCampusByCompany(res.data.companyId);

        await fetchAllType(res.data.companyId);
        await fetchAllTypeByCategory(res.data.itemTypeTBL.categoryId);
        await fetchAllDepartment(res.data.companyId);
        await fetchAllSupplier(res.data.companyId);
        await fetchAllBrand(res.data.companyId);
        await fetchAllStatus(res.data.companyId);
        await fetchUser(res.data.companyId);
        await fetchAllCategoryName(res.data.companyId);

        if (isExternal) {
          if (res.data.locationTBL?.campusTBL) {
            const currentCampus = allCampuses.find(c => c.campusId === res.data.locationTBL.campusTBL.campusId);
            if (currentCampus) {
              setCampusData(prev => {
                const exists = prev.find(c => c.campusId === currentCampus.campusId);
                return exists ? prev : [...prev, currentCampus];
              });
            }
          }

          if (res.data.locationTBL) {
            const currentLocation = allLocations.find(l => l.locationId === res.data.locationId);
            if (currentLocation) {
              setLocationData(prev => {
                const exists = prev.find(l => l.locationId === currentLocation.locationId);
                return exists ? prev : [...prev, currentLocation];
              });
            }
          }
        }

        setSelectedCompany(res.data.companyId);
        setSelectedLocation(res.data.locationId);
        setSelectedCategory(res.data.itemTypeTBL.categoryId);
        setSelectedDepartment(res.data.departmentId);
        setSelectedBrand(res.data.brandId);
        setSelectedType(res.data.typeId);
        setSelectedSupplier(res.data.supplierId);
        setSelectedDebit(res.data.debtUserId);
        setSelectedStatus(res.data.inventoryStatusId);
        setSelectedCampus(res.data.locationTBL.campusId);
      }
    } catch (err) {
      console.error(err);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  const DeletePicture = (pictureId: number) => {
    HTTPService.DELETE(`/Inventory/deletePicture?pictureId=${pictureId}`).then(async (res) => {
      if (res.status === 200) {
        toast.current?.show({
          severity: 'success',
          summary: t('successful'),
          detail: t(res.data),
          life: 3000
        });
        setItemData(prevItemData => ({
          ...prevItemData,
          inventoryPictureTBL: prevItemData.inventoryPictureTBL.filter(picture => picture.pictureId !== pictureId)
        }));
      }
      else if (res.status === 450) {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(res.data),
          life: 3000
        });
      }
      else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(res.data),
          life: 3000
        });
      }
    }).catch(err => {
      console.error(err);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    });
  };

  const isImageFile = (fileType: string): boolean => {
    if (!fileType) return false;


    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
    const extension = fileType.substring(fileType.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  };


  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (fileList) {
      const files = Array.from(fileList) as File[];

      setSelectedImages(prevImages => {
        const currentTotalImages = itemData.inventoryPictureTBL.length + prevImages.length;
        const availableSlots = 3 - currentTotalImages;

        if (availableSlots <= 0) {
          notification.warning({
            message: t('limit_exceeded'),
            description: t('threeImage'),
          });
          event.target.value = '';
          return prevImages;
        }

        const allowedFiles = files.slice(0, availableSlots);

        if (allowedFiles.length < files.length) {
          notification.warning({
            message: t('limit_exceeded'),
            description: t('threeImage'),
          });
        }

        event.target.value = '';
        return [...prevImages, ...allowedFiles];
      });
    }
  };


  const showModalCampus = () => {
    setIsModalVisibleCampus(true);
  };

  const showModalStatus = () => {
    setIsModalVisibleInventoryStatus(true);
  };

  const showModalBrand = () => {
    setIsModalVisibleBrand(true);
  };

  const showModalDepartment = (id: number) => {
    setIsModalVisibleDepartment(true);
  };

  const showModalSupplier = () => {
    setIsModalVisibleSupplier(true);
  };


  const showModalType = () => {
    setIsModalVisibleType(true);
  };


  const showModalLocation = () => {
    setIsModalVisibleLocation(true);
  };

  const handleCancelCampus = () => {
    setIsModalVisibleCampus(false);
    fetchCampusByCompany(selectedCompany || user.companyId)
  };

  const handleCancelBrand = () => {
    setIsModalVisibleBrand(false);
    fetchAllBrand(itemData.companyId)
  };

  const handleCancelStatus = () => {
    setIsModalVisibleInventoryStatus(false);
    fetchAllStatus(itemData.companyId)
  };


  const handleCancelDepartment = () => {
    setIsModalVisibleDepartment(false);
    fetchAllDepartment(itemData.companyId);
  };

  const handleCancelSupplier = () => {
    setIsModalVisibleSupplier(false);
    fetchAllSupplier(itemData.companyId)
  };


  const handleCancelCategory = () => {
    setIsModalVisibleCategory(false);
    fetchAllCategoryName(itemData.companyId)
  };

  const handleCancelType = () => {
    setIsModalVisibleType(false);
    fetchAllType(selectedCompany)
    fetchAllTypeByCategory(selectedCategory.toString())
  };

  const fetchAllLocationNameByCampus = async (campusId: string) => {
    try {
      const result = await HTTPService.GETAllLocationNameByCampus(campusId);
      const filtered = result.filter(location => {
        const locationName = location.locationName?.toLowerCase() || '';
        return !locationName.includes('dışı') &&
          !locationName.includes('external') &&
          !locationName.includes('company outside');
      });
      setLocationData(filtered);
      return result; // Tüm veriyi döndür
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
      return [];
    }
  };

  const columns: IAltisDataGridColumns[] = [
    {
      title: t('Responsible Name'),
      key: 'displayName',
      placeHolder: t('Responsible Name'),
      inputType: "input",
    },
    {
      title: t('Operations'),
      key: 'operations',
      placeHolder: t('Operations'),
      inputType: "operations",

      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Space size={50}>
            <Popconfirm
              title={<div>
                {t('responsibleToast')} <br />
              </div>}
              onConfirm={() => DeleteResponsible(record.userId)}
              okText={t('Yes')}
              cancelText={t('No')}
            >
              <Button
                size='small'
                icon={<DeleteOutlined />}
                onClick={(e) => { e.stopPropagation(); }}
              >{t('Delete')}</Button>
            </Popconfirm>
          </Space>
        </div>
      ),
    },
  ];

  const DeleteResponsible = (id: number) => {

    setFilteredUserData(prevData => prevData.filter(item => item.userId != id));
    const responsible = userData.find(responsible => responsible.userId === id);
    if (responsible) {
      toast.current?.show({
        severity: 'success',
        summary: t('successful'),
        detail: `"${responsible.displayName}" ${t('responsibleDeleteToast')}`,
        life: 3000
      });
    } else {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('responsibleNotFound'),
        life: 3000
      });
    }
  };

  useEffect(() => {
  }, [filteredUserData]);

  const handleAddResponsible = () => {
    const selectedUserData = userData.find(user => user.userId === selectedResponsible);

    if (selectedUserData && !filteredUserData.some(user => user.userId === selectedUserData.userId)) {
      setFilteredUserData(prevData => [
        ...prevData,
        { userId: selectedUserData.userId, displayName: selectedUserData.displayName }
      ]);
    }
  };

  const showModalCategory = () => {
    setIsModalVisibleCategory(true);
  };

  const fetchCampusByCompany = async (companyId: number) => {
    try {
      const result = await HTTPService.GETCampusesByCompany(companyId);
      const filtered = result.filter(campus => {
        const campusName = campus.campusName?.toLowerCase() || '';
        return !campusName.includes('dışı') &&
          !campusName.includes('external') &&
          !campusName.includes('company outside');
      });
      setCampusData(filtered);
      return result; // Tüm veriyi döndür
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
      return [];
    }
  };

  const handleCancelLocation = () => {
    setIsModalVisibleLocation(false);
    fetchAllLocationName(selectedCompany);
    fetchAllLocationNameByCampus(selectedCampus.toString())
  };

  const savedNewCampus = (campus: ICampusData) => {
    setSelectedCampus(campus.campusId)
  }

  const savedNewLocation = (location: ILocationData) => {
    setSelectedLocation(location.locationId)
  }

  const savedNewCategory = (category: ICategoryData) => {
    setSelectedCategory(category.categoryId)
  }

  const savedNewType = (type: ITypeData) => {
    setSelectedType(type.typeId)
  }

  const savedNewDepartment = (department: IDepartmentData) => {
    setSelectedDepartment(department.departmentId)
  }

  const savedNewSupplier = (supplier: ISupplierData) => {
    setSelectedSupplier(supplier.supplierId)
  }

  const savedNewBrand = (brand: IBrandData) => {
    setSelectedBrand(brand.brandId)
  }


  const savedNewStatus = (status: IInventoryStatusData) => {
    setSelectedStatus(status.inventoryStatusId)
  }


  const handleClickDeparment: React.MouseEventHandler<HTMLElement> = (event) => {
    showModalDepartment(itemData?.companyId)
  };

  const updatedItem = (formData) => {

    var companyId = user.companyId == -1 ? selectedCompany : user?.companyId
    const updatedItem = {
      companyId: companyId,
      inventoryId: inventoryId,
      inventoryName: formData.inventoryName,
      serialNo: formData.serialNo,
      barcode: formData.barcode || formData.customBarcode,
      customBarcode: formData.customBarcode,
      epc: formData.epc,
      nfc: formData.nfc,
      referanceNo: formData.referanceNo,
      actualLocationId: selectedLocation,
      departmentId: selectedDepartment,
      supplierId: selectedSupplier,
      brandId: selectedBrand,
      categoryId: selectedCategory,
      inventoryStatusId: selectedStatus,
      typeId: selectedType,
      debtUserId: selectedDebit,
      inventoryResponsibleTBL: filteredUserData.map(user => ({
        responsibleUserId: user.userId,
        inventoryId: inventoryId,
      }))
    };

    HTTPService.PUT(`/Inventory/updateInventory`, updatedItem)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          window.location.replace('/admin/inventory-management');
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
        else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('update_failed'),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error(t('update_failed'));
      });
  };


  if (selectedImages.length > 0 && selectedImages.length < 4) {
    const formData = new FormData();

    selectedImages.forEach((image, index) => {
      formData.append('file', image);
      formData.append('inventoryId', inventoryId);
    });

    HTTPService.PUT(`/Inventory/updateInventoryPicture`, formData)
      .then((response) => {
        if (response.status === 200) {
          var tmp = { ...itemData };
          tmp.inventoryPictureTBL = tmp.inventoryPictureTBL.concat(response.data);
          setSelectedImages([])
          setItemData(tmp)
          setSelectedImages([])
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          //setSelectedImages(response.data)
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
        else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('update_failed'),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error(t('update_failed'));
      });
  }

  //const handleImageRemove = (index: number) => {
  //setSelectedImages(prevImages => prevImages.filter((_, i) => i !== index));
  //DeletePicture(itemData.inventoryPictureTBL.find(picture=>picture.pictureId))
  //};


  const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
    return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
  };

  const handleSelectChange = (value) => {
    setSelectedResponsible(value);

    toast.current?.show({
      severity: 'warn',
      summary: t('Warning'),
      detail: t('pressPlusIcon'),
      life: 3000
    });
  };

  const handleGridChange = () => {
    fetchUser(selectedCompany);
  };

  const handleChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  const fetchUser = async (companyId: number) => {
    try {
      const result = await HTTPService.GETUserNames(companyId);
      setUserData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <h3>{t('update_item')}</h3>
      <Form
        layout='vertical'
      // onFinish={updatedPicture}
      >
        <Card style={{ padding: '50px' }}>
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {itemData && itemData.inventoryPictureTBL && itemData.inventoryPictureTBL.length > 0 && (
                itemData.inventoryPictureTBL
                  .filter(picture => isImageFile(picture.pictureGuid))
                  .map((picture, index) => (
                    <div
                      key={index}
                      style={{
                        position: 'relative',
                        width: '150px',
                        height: '150px',
                      }}
                    >
                      <Image
                        src={`${API_URL}/images/${picture.pictureGuid}`}
                        alt={`Resim ${index}`}
                        width={150}
                        height={150}
                        preview={false}
                        style={{ borderRadius: '4px' }}
                      />
                      <Button
                        icon={<DeleteOutlined />}
                        onClick={() => DeletePicture(picture.pictureId)}
                        style={{
                          position: 'absolute',
                          bottom: '10px',
                          right: '10px',
                          zIndex: 1,
                        }}
                        type="primary"
                        danger
                      />
                    </div>
                  ))
              )}
              <div style={{ marginLeft: '220px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                <div style={{ marginBottom: '10px', display: 'flex', flexWrap: 'wrap' }}>
                  <label style={{ fontWeight: "bold", marginRight: '10px' }}>{t('inventoryName')}:</label>
                  <span>{itemData.inventoryName}</span>
                </div>
                <div style={{ marginBottom: '10px', display: 'flex', flexWrap: 'wrap' }}>
                  <label style={{ fontWeight: "bold", marginRight: '10px' }}>{t('serialNo')}:</label>
                  <span>{itemData.serialNo}</span>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <label style={{ fontWeight: "bold", marginRight: '10px' }}>{t('barcode')}:</label>
                  <span>{itemData.customBarcode ? itemData.customBarcode : itemData.barcode}</span>
                </div>
              </div>
            </div>
          </div>
          {/* Form item for uploading new images */}
          <Form.Item
            name='images'
            label={t('upload_image')}
          >
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                ref={fileInputRef}
                style={{ display: 'none' }}
                multiple
              />
              <Button
                icon={<UploadOutlined />}
                onClick={() => fileInputRef.current.click()}
                style={{ marginTop: '20px' }}
              >
                {t('Select Images')}
              </Button>
            </div>
          </Form.Item>
        </Card>
      </Form>
      <br></br>

      <Card style={{ padding: '50px' }}>
        <Box sx={{ width: "100%", marginBottom: 2, display: 'flex', justifyContent: 'flex-start' }}>
          <Tabs value={tabIndex} onChange={handleChange}>
            <Tab label={t("general")} />

            <Tab
              disabled={!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  {t("subParts")}
                  {!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin && <LockIcon fontSize="small" />}
                </Box>
              }
            />

            <Tab
              disabled={!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  {t("waranity")}
                  {!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin && <LockIcon fontSize="small" />}
                </Box>
              }
            />

            <Tab
              disabled={!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  {t("files")}
                  {!user.licencePackage?.isMaintenance && user.role !== UserRole.AltisAdmin && <LockIcon fontSize="small" />}
                </Box>
              }
            />
          </Tabs>
        </Box>

        {tabIndex === 0 && (
          <Box>
            <Form
              layout='vertical'
              onFinish={updatedItem}
              fields={[
                { name: ["inventoryName"], value: itemData?.inventoryName },
                { name: ["serialNo"], value: itemData?.serialNo },
                { name: ["epc"], value: itemData?.epc },
                { name: ["nfc"], value: itemData?.nfc },
                { name: ["customBarcode"], value: itemData?.customBarcode },
                { name: ["campusId"], value: itemData?.locationTBL?.campusTBL?.campusId },
                { name: ["locationId"], value: itemData?.locationId },
                { name: ["categoryId"], value: itemData.itemTypeTBL?.categoryId },
                { name: ["typeId"], value: itemData?.typeId },
                { name: ["departmentId"], value: itemData?.departmentId },
                { name: ["supplierId"], value: itemData?.supplierId },
                { name: ["brandId"], value: itemData?.brandId },
                { name: ["inventoryStatusId"], value: itemData?.inventoryStatusId },
                { name: ["referanceNo"], value: itemData?.referanceNo },
                { name: ["debtUserId"], value: itemData?.debtUserId },
              ]}
            >

              {/* Campus Select */}
              <Form.Item
                //name='campusId'
                label={t('campus')}
                rules={[{ message: t('select_campus') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Select
                  placeholder={t('campus')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedCampus}
                  disabled={isLocationExternal}
                  onChange={(value) => (setSelectedCampus(value), setSelectedLocation(""), fetchAllLocationNameByCampus(value.toString()))}
                  filterOption={filterOption}
                >
                  {campusData.map(row => (
                    <Select.Option key={row.campusId} value={row.campusId}>
                      {row.campusName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Campus Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalCampus}
                      disabled={isLocationExternal}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>

              {/* Location Select */}
              <Form.Item
                //name='locationId'
                label={t('location')}
                rules={[{ required: true, message: t('select_location') }]}
                style={{ marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('location')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedLocation}
                  dataSource={locationData}
                  disabled={isLocationExternal}
                  labelKey="locationName"
                  valueKey="locationId"
                  includeEmptyOption={false}
                  onChange={(value) => setSelectedLocation(value as string | number)}
                />

              </Form.Item>

              {/* Location Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalLocation}
                      disabled={isLocationExternal}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>

              </Form.Item>

              <Modal
                visible={isModalVisibleLocation}
                footer={null}
                onCancel={handleCancelLocation}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddLocation savedObj={savedNewLocation} cancelModal={handleCancelLocation} companyId={itemData.companyId} campusId={itemData?.locationTBL?.campusTBL?.campusId} locationId={itemData.locationId} locationName={itemData.locationName} />
              </Modal>

              <Modal
                visible={isModalVisibleCampus}
                footer={null}
                onCancel={handleCancelCampus}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddCampus cancelModal={handleCancelCampus} savedObj={savedNewCampus} companyId={itemData.companyId} campusName={itemData.locationTBL?.campusTBL?.campusName} />
              </Modal>

              {/* Category Select */}
              <Form.Item
                //name='categoryId'
                label={t('item_group')}
                rules={[{ required: true, message: t('category') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('item_group')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedCategory}
                  dataSource={categoryData}
                  labelKey="categoryName"
                  valueKey="categoryId"
                  includeEmptyOption={false}
                  onChange={(value: string | number | (() => void) | ((category: ICategoryData) => void)) => {
                    if (typeof value === 'string' || typeof value === 'number') {
                      setSelectedCategory(value);
                      setSelectedType('');
                      fetchAllTypeByCategory(value.toString());
                    }
                  }}
                />
              </Form.Item>

              {/* Category Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalCategory}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Modal
                visible={isModalVisibleCategory}
                footer={null}
                onCancel={handleCancelCategory}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddCategory cancelModal={handleCancelCategory} savedObj={savedNewCategory} companyId={itemData.companyId} categoryId={itemData?.itemTypeTBL?.categoryId} categoryName={itemData?.itemTypeTBL?.categoryTBL?.categoryName} />
              </Modal>

              {/* Category Select */}
              <Form.Item
                //name='typeId'
                label={t('item_type')}
                rules={[{ required: true, message: t('type') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('item_type')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedType}
                  onChange={(value) => {
                    if (typeof value === 'string' || typeof value === 'number') {
                      setSelectedType(value);
                    }
                  }}
                  dataSource={typeData}
                  labelKey="typeName"
                  valueKey="typeId"
                  includeEmptyOption={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalType}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Modal
                visible={isModalVisibleType}
                footer={null}
                onCancel={handleCancelType}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddType cancelModal={handleCancelType} savedObj={savedNewType} companyId={itemData.companyId} categoryId={itemData?.itemTypeTBL?.categoryTBL?.categoryId} typeName={itemData?.itemTypeTBL?.typeName} typeId={itemData?.itemTypeTBL?.typeId} />
              </Modal>

              <Form.Item
                //name='departmentId'
                label={t('Department')}
                rules={[{ required: true, message: t('Department') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Select
                  placeholder={t('Department')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedDepartment}
                  filterOption={filterOption}
                  onChange={(value) => setSelectedDepartment(value)
                  }>

                  {departmentData.map(row => (
                    <Select.Option key={row.departmentId} value={row.departmentId}>
                      {row.departmentName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Category Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={handleClickDeparment}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>

              <Modal
                visible={isModalVisibleDepartment}
                footer={null}
                onCancel={handleCancelDepartment}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddDepartment cancelModal={handleCancelDepartment} savedObj={savedNewDepartment} companyId={itemData.companyId} departmentId={itemData.departmentId} departmentName={itemData.departmentName} />
              </Modal>

              <Form.Item
                //name='supplierId'
                label={t('supplier')}
                rules={[{ required: true, message: t('supplier') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('supplier')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedSupplier}
                  onChange={(value) => {
                    if (typeof value === 'string' || typeof value === 'number') {
                      setSelectedSupplier(value);
                    }
                  }}
                  dataSource={supplierData}
                  labelKey="supplierName"
                  valueKey="supplierId"
                  includeEmptyOption={false}
                />
              </Form.Item>

              {/* Category Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalSupplier}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>
              <Modal
                visible={isModalVisibleSupplier}
                footer={null}
                onCancel={handleCancelSupplier}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddSupplier cancelModal={handleCancelSupplier} savedObj={savedNewSupplier} companyId={itemData.companyId} supplierName={itemData.supplierName} supplierId={itemData.supplierId} />
              </Modal>

              <Form.Item
                //name='brandId'
                label={t('brand')}
                rules={[{ required: true, message: t('brand') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('brand')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedBrand}
                  onChange={(value) => {
                    if (typeof value === 'string' || typeof value === 'number') {
                      setSelectedBrand(value);
                    }
                  }}
                  dataSource={brandData}
                  labelKey="brandName"
                  valueKey="brandId"
                  includeEmptyOption={false}
                />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalBrand}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>
              <Modal
                visible={isModalVisibleBrand}
                footer={null}
                onCancel={handleCancelBrand}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddBrand cancelModal={handleCancelBrand} savedObj={savedNewBrand} companyId={itemData.companyId} brandName={itemData.brandName} brandId={itemData.brandId} />
              </Modal>

              <Form.Item
                //name='inventoryStatusId'
                label={t('inventory_status_name')}
                rules={[{ required: true, message: t('inventory_status_name') }]}
                style={{ marginTop: -10, marginBottom: 0 }}
              >
                <Dropdown
                  placeholder={t('inventory_status_name')}
                  style={{ width: 'calc(100% - 50px)' }}
                  dropdownStyle={{ minWidth: 300 }}
                  value={selectedStatus}
                  onChange={(value) => {
                    if (typeof value === 'string' || typeof value === 'number') {
                      setSelectedStatus(value);
                    }
                  }}
                  dataSource={inventoryStatusData}
                  labelKey="inventoryStatusName"
                  valueKey="inventoryStatusId"
                  includeEmptyOption={false}
                />
              </Form.Item>

              {/* Category Button */}
              <Form.Item
                style={{ marginBottom: 0, marginTop: -8 }}
              >
                <Row justify="end">
                  <Col>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={showModalStatus}
                      style={{ marginLeft: 8, marginTop: -55 }}  // Responsive margin
                    />
                  </Col>
                </Row>
              </Form.Item>
              <Modal
                visible={isModalVisibleInventoryStatus}
                footer={null}
                onCancel={handleCancelStatus}
                width={800}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '25vh' }}
              >
                <AddInventoryStatus savedObj={savedNewStatus} cancelModal={handleCancelStatus} companyId={itemData.companyId} inventoryStatusName={itemData.inventoryStatusName} inventoryStatusId={itemData.inventoryStatusId}
                />
              </Modal>

              <Form.Item
                //name='debtUserId'
                label={t('Debit Name')}
                rules={[{ required: false, message: t('debit_name') }]}
              >
                <Dropdown
                  placeholder={t('Debit Name')}
                  value={selectedDebit}
                  onChange={(value) => setSelectedDebit(value)}
                  dataSource={userData}
                  labelKey="displayName"
                  valueKey="userId"
                  includeEmptyOption={true}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item
                name='responsibleList'
                label={t('responsibleName')}
                rules={[{ required: false, message: t('selectResponsible') }]}
                style={{ marginBottom: 0 }}
              >
                <Row gutter={8} align="middle">
                  <Col flex="auto">
                    <Select
                      showSearch
                      placeholder={t('selectResponsible')}
                      onChange={handleSelectChange}
                      filterOption={filterOption}
                    >
                      {userData?.map((responsible) => (
                        <Select.Option key={responsible.userId} value={responsible.userId}>
                          {responsible.displayName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col>
                    <Button style={{ borderRadius: '5px' }} type="primary" onClick={handleAddResponsible}>
                      {t('addResponsible')}
                    </Button>
                  </Col>
                </Row>
                <br></br>
                <AltisDataGrid
                  data={filteredUserData}
                  total={filteredUserData.length}
                  columns={columns}
                  onChange={handleGridChange}
                />
                <br></br>
              </Form.Item>

              <Form.Item
                name='inventoryName'
                label={t('inventoryName')}
                rules={[{ required: true, message: t('input_item_name'), whitespace: true }]}
              >
                <Input
                  placeholder={t('item-name')}
                  value={itemData.inventoryName}
                  onChange={(e) => setItemData(prevData => ({ ...prevData, inventoryName: e.target.value }))}
                />
              </Form.Item>




              <Form.Item
                name="customBarcode"
                label={t("barcode")}
                rules={[
                  { message: t("input_barcode"), whitespace: true },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      if (/^\d+$/.test(value)) {
                        if (value.length > 32) {
                          return Promise.reject(new Error(t("barcode_max_length", { length: 32 })));
                        }
                      }
                      else if (/^[a-zA-Z]+$/.test(value)) {
                        if (value.length > 16) {
                          return Promise.reject(new Error(t("barcode_max_length", { length: 16 })));
                        }
                      }
                      else if (/^[a-zA-Z0-9]+$/.test(value)) {
                        if (value.length > 16) {
                          return Promise.reject(new Error(t("barcode_max_length_16", { length: 16 })));
                        }
                      } else {
                        if (value.length > 16) {
                          return Promise.reject(new Error(t("barcode_max_length_16", { length: 16 })));
                        }
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder={t("barcode")} style={{ borderRadius: "0" }} />
              </Form.Item>





              <Form.Item
                name='nfc'
                label={t('nfc')}
                rules={[{ message: t('input_nfc'), whitespace: true },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    if (/^\d+$/.test(value)) {
                      if (value.length > 32) {
                        return Promise.reject(new Error(t("nfc_max_length", { length: 32 })));
                      }
                    }
                    else if (/^[a-zA-Z]+$/.test(value)) {
                      if (value.length > 16) {
                        return Promise.reject(new Error(t("nfc_max_length", { length: 16 })));
                      }
                    }
                    else if (/^[a-zA-Z0-9]+$/.test(value)) {
                      if (value.length > 16) {
                        return Promise.reject(new Error(t("nfc_max_length_16", { length: 16 })));
                      }
                    } else {
                      if (value.length > 16) {
                        return Promise.reject(new Error(t("nfc_max_length_16", { length: 16 })));
                      }
                    }

                    return Promise.resolve();
                  },
                },
                ]}

              >
                <Input
                  placeholder={t('nfc')}
                  style={{ borderRadius: '0' }}
                />
              </Form.Item>


              <Form.Item
                name='epc'
                label={t('epc')}
                rules={[{ message: t('input_epc'), whitespace: true }]}
              >
                <Input
                  placeholder={t('epc')}
                  style={{ borderRadius: '0' }}
                />
              </Form.Item>


              <Form.Item
                name='serialNo'
                label={t('serial_no')}
                rules={[{ required: false, message: t('input_serial_no'), whitespace: true }]}
              >
                <Input
                  placeholder={t('serial_no')}
                  value={itemData.serialNo}
                  onChange={(e) => setItemData(prevData => ({ ...prevData, serialNo: e.target.value }))}
                />
              </Form.Item>

              <Form.Item
                name='referanceNo'
                label={t('Referance No')}
              >
                <Input
                  placeholder={t('Referance No')}
                  value={itemData.referanceNo}
                />
              </Form.Item>

              <Form.Item>
                <Row gutter={[4, 4]} justify="end" align="middle">
                  <Col xs={12} sm={12} md={4}>
                    <Button
                      block
                      href="/admin/inventory-management"
                      type="primary"
                      style={{
                        height: 64,
                        backgroundColor: 'transparent',
                        color: '#1890ff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 10px',
                        border: 'none',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                        e.currentTarget.style.color = '#40a9ff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.color = '#1890ff';
                      }}
                    >
                      <CloseOutlined style={{ fontSize: 20 }} />
                      <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                        {t('cancel')}
                      </span>
                    </Button>
                  </Col>
                  <Col xs={12} sm={12} md={4}>
                    <Button
                      block
                      htmlType="submit"
                      type="primary"
                      style={{
                        height: 64,
                        backgroundColor: 'transparent',
                        color: '#1890ff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 10px',
                        border: 'none',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                        e.currentTarget.style.color = '#40a9ff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.color = '#1890ff';
                      }}
                    >
                      <SyncOutlined style={{ fontSize: 20 }} />
                      <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                        {t('update')}
                      </span>
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Box>
        )}

        {/* {tabIndex === 1 && (
          <Box>
            <MaintenanceTab inventoryId={inventoryId} setTabIndex={setTabIndex} />
          </Box>
        )} */}

        {tabIndex === 1 && (
          <Box>
            <SubPartsTab inventoryId={inventoryId} setTabIndex={setTabIndex} companyId={itemData.companyId} />
          </Box>
        )}

        {tabIndex === 2 && (
          <Box>
            <WarrantyTab inventoryId={inventoryId} setTabIndex={setTabIndex} />
          </Box>
        )}

        {tabIndex === 3 && (
          <Box>
            <FileTab inventoryId={Number(inventoryId)} />
          </Box>
        )}
      </Card>
    </>
  );
};

export default UpdateInventory;